export const validateEmail = (email: string) => {
  return !!email.match(
    // eslint-disable-next-line regexp/use-ignore-case, regexp/no-useless-escape, regexp/strict, regexp/prefer-d
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  )
}
